module.exports = __webpack_public_path__ + "img/icon_email.8324d81a.png";